import { render, staticRenderFns } from "./MasterEdit_new.vue?vue&type=template&id=36b9b4a6&"
import script from "./MasterEdit_new.vue?vue&type=script&lang=js&"
export * from "./MasterEdit_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports